<template>
  <div>
    <vx-card class="mt-5">
      <a-form :form="form" @submit.prevent="handleRecordPayment">
        <div class="flex justify-between flex-row-reverse space-x-2">
<!--          <div class="space-x-2"></div>-->
<!--            <a-button type="primary" ghost style="border-radius: 3px !important;" @click="$router.push('/billing')">Cancel</a-button>-->
          <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">Record Payment</a-button>
          <div class="text-xl font-semibold">
            Record Payment
          </div>
        </div>
        <a-divider/>
        <div class="grid grid-cols-1 md:grid-cols-3 md:gap-4">
          <a-form-item label="Client">
            <a-select
              placeholder="Type to search client"
              allowClear
              class="select"
              show-search
              :filter-option="filterOption"
              :loading="loading"
              @change="handleChangeClient"
              v-decorator="['from_client',{ rules: [{ required: true, message: 'This field is required.' }] }]"
            >
              <a-select-option v-for="contact in contacts" :value="contact.id">
                <template v-if="contact.person">
                  {{ contact.person.first_name }} {{ contact.person.last_name }}
                </template>
                <template v-else>
                  {{ contact.company.name }}
                </template>
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Source" has-feedback>
            <a-select
              placeholder="Select payment source"
              allowClear
              class="select"
              :loading="loading"
              v-decorator="['source',{ initialValue:'Direct',rules: [{ required: true, message: 'This field is required.' }] }]"
              @change="handleChangeSource"
            >
              <a-select-option value="Direct">
                Direct payment
              </a-select-option>
              <template v-if="typePayment === '1'">
                <a-select-option v-for="source in sourceOptions" :value="source.id">
                  {{ source.bank_account.account_name }} - {{ sourceName(source) +  '(' + 'RM' + source.balance + ')' }}
                </a-select-option>
              </template>
            </a-select>
          </a-form-item>
          <a-form-item label="Reference" has-feedback>
            <a-input
              placeholder="Enter a reference"
              allowClear
              class="select w-full"
              v-decorator="['ref_id',{rules: [{ required: false, message: 'This field is required.' }] }]"
            />
          </a-form-item>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 md:gap-4">
          <a-form-item label="Payment date" has-feedback>
            <a-date-picker
              v-decorator="['created_at',{ initialValue: new Date().toISOString().split('T')[0],rules: [{ required: true, message: 'This field is required.' }] }]"
              :format="dateFormat"
              valueFormat="YYYY-MM-DD"
              class="w-full"
            />
          </a-form-item>
          <a-form-item label="Destination" has-feedback>
            <a-select
              allowClear
              class="select w-full"
              :loading="loading"
              v-decorator="['destination',{ rules: [{ required: true, message: 'This field is required.' }] }]"
            >
              <a-select-option v-for="account in destinationOptions" :value="account.id">
                {{ account.account_name }} {{ account.balance !== null ? '- RM' + account.balance : '' }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <ACard class="mt-5">
          <ACard>
            <div class="flex flex-col md:flex-row w-full md:w-1/3 gap-y-4">
              <div class="flex flex-col gap-y-2 items-center mr-0 md:mr-10">
                <strong class="mt-1" style="white-space: nowrap">Total open balance</strong>
<!--                <div>{{ +total_amount || '-' }}</div>--> <!-- Why do we have the + sign here? -->
                <div v-if="total_amount">{{ total_amount.toFixed(2) || '-' }}</div>
              </div>
              <a-form-item label="Payment amount" id="payment-field">
                <a-input
                  v-decorator="['amount',{ rules: [
                    { required: false, message: 'This field is required.' },
                    { validator: (rule,value)=> hasAmountSmallerBalance(value) , message:'The transfer value must be smaller than the source value.' }]
                  }]"
                  :prefix="currencySymbol"
                  class="amount-payment"
                  @keyup="setFieldAmount"
                >
                  <template slot="suffix">
                    <a-button type="link" class="p-0" @click="setMaxAmount(total_amount)">Max</a-button>
                  </template>
                </a-input>
              </a-form-item>
            </div>
          </ACard>
          <XTable
            class="mt-5"
            ref="recordPayment"
            :options="{placeholder:'Search payment', noContent: 'No bill payment' , is_row_selection: false , is_load_req: false}"
            :model="model"
          >
            <span slot="bill_id" slot-scope="text,record">
              <a-button type="link" @click="dashboardId(text.record.id)">{{ text.record.factor_no }}</a-button>
            </span>
            <span slot="matters" slot-scope="text,record">
              <template v-for="matter in text.record.matters">
                <a-popover>
                  <template slot="content">
                    <p>{{ matter.title }}</p>
                  </template>
                  <a-tag style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; max-width: 8rem;">
                    {{ matter.title }}
                  </a-tag>
                </a-popover>
              </template>
            </span>
            <span slot="payment" slot-scope="text,record,index">
            <a-form-item>
                 <a-input
                   v-decorator="[`bills_pays[${text.index}]`,{ rules: [{validator: ()=> checkTotalAmount (`bills_pays[${text.index}]`,text.record) ,message: 'The amount is more than the total record balance.'},{ required: false, message: 'This field is required.' }] }]"
                   :prefix="currencySymbol"
                   class="amount-payment w-full md:w-3/4"
                 />
            </a-form-item>
          </span>
            <span slot="paid" slot-scope="text,record">
            {{ text.record.payed_amount.toFixed(2) }}
          </span>
            <span slot="amount" slot-scope="text,record">
              <span v-if="text.record.is_old_version || text.record.type === 2">{{ text.record.total_amount.toFixed(2) }}</span>
              <span v-else>{{ text.record.fixed_total_amount.toFixed(2) }}</span>
            </span>
            <span slot="issue_date" slot-scope="text,record">
               {{ setDateFormat(text.record.issue_date) }}
            </span>
            <span slot="due_date" slot-scope="text,record">
               {{ setDateFormat(text.record.due_date) }}
            </span>
          </XTable>
<!--          <a-empty>-->
<!--            <span slot="description">Select a client to record a payment.</span>-->
<!--          </a-empty>-->
        </ACard>
      </a-form>
    </vx-card>
  </div>

</template>

<script>
import mixin from '../mixin/mixin'
import selectSearch from "@/views/forms/selectSearch";
import axios from '@/axios'
import * as TableCol from "./paymentTbl";
import XTable from "../../components/x-table/XTable";

export default {
  name: "BillingPayment",
  mixins:[mixin],
  components: {
    selectSearch,
    XTable
  },
  data() {
    return {
      contacts          : [],
      destinationOptions: [],
      sourceOptions     : [],
      billings          : [],
      model             : null,
      sourceSelected    : null,
      total_amount      : undefined,
      typePayment       : this.$route.query.type,
      loading           : false
    }
  },
  computed: {
    currencySymbol() {
      return localStorage.getItem('currency_symbol')
    },
  },
  methods:{
    sourceName(source) {
      if(source.type === 3) return source.owner.title
      if (source.type === 2) {
        if (source.owner.person) return source.owner.person.first_name + ' ' + source.owner.person.last_name
        return source.owner.company.name
      }
      return '--'
    },

    checkTotalAmount(field, record) {
      if (this.form.getFieldValue(field) !== undefined) {
        if (record.is_old_version || record.type === 2)
          return this.form.getFieldValue(field) <= (record.total_amount - record.payed_amount)
        else
          return this.form.getFieldValue(field) <= (record.fixed_total_amount - record.payed_amount)
      }
      return true
    },

    setMaxAmount(amount) {
      if (amount) {
        this.form.setFieldsValue({ amount: amount.toFixed(2) })
        this.setFieldAmount(amount)
        this.hasAmountSmallerBalance(amount)
      }
    },

    setFieldAmount(amount) {
      let fillAmounts = []
      let curAmount = (amount.target && amount.target.value)
        ? parseFloat(amount.target.value)
        : parseFloat(this.total_amount)
      
      for (let i=0; i < this.billings.length; i++) {
        const totalAmount = (this.billings[i].is_old_version || this.billings[i].type === 2)
          ? this.billings[i].total_amount
          : this.billings[i].fixed_total_amount
        
        const unpaid = (totalAmount - this.billings[i].payed_amount)
        if (curAmount <= unpaid) {
          fillAmounts.push(curAmount)
          curAmount = 0
        } else {
          fillAmounts.push(unpaid)
          curAmount =  curAmount - unpaid
        }
      }
      this.billings.map((item, ind) => {
        this.form.setFieldsValue({[`bills_pays[${ind}]`]: Number(fillAmounts[ind]).toFixed(2) })
      })
    },

    selectContact(id) {
      this.filterBilling(id)
    },

    async filterBilling(id) {
      this.$refs.recordPayment.query.query = [
        { condition: '=' , value: id , field: 'to_contact'  },
        { operation:'and',condition: '=' , value: 3 , field: 'status' },
      ]
      await this.$refs.recordPayment.fetch()
      const billings     = this.$refs.recordPayment.data
      this.billings      = billings
      const sum_amount   = billings.reduce((partial_sum, item) => {
        if (item.is_old_version || item.type === 2)
          return partial_sum + item.total_amount
        else return partial_sum + item.fixed_total_amount
      }, 0)
      const payed_amount = billings.reduce((partial_sum, item) => partial_sum + item.payed_amount, 0)
      this.total_amount  = sum_amount - payed_amount
    },

    async getContacts() {
      try {
        this.loading = true
        const { data } = await axios.post('/contact/query/',{limit:999})
        this.contacts = data.rows
      } catch (e) {
        throw e
      } finally {
        this.loading = false
      }
    },
    
    async getSources(id) {
      try {
        this.loading = true
        if (id) {
          const {data} = await axios.post(`/bank-account/get-client-balance/${id}/`,
            { query: [{ field: 'bank_account__account_type', condition: '=' , value: 2 }] })
          this.sourceOptions = data.rows
        }
      } catch (e) {
        throw new Error(e)
      } finally {
        this.loading = false
      }
    },
    async getBankAccounts() {
      try {
        this.loading = true

        const accountName = this.contacts
          .filter(elem => elem.id === this.form.getFieldValue('from_client'))
          .map(elem => {
            if (elem.person)
              return `${elem.person.first_name} ${elem.person.last_name}`
            else return elem.company.name
          })

        let query
        // if (Number(this.typePayment) === 2)
        //   query = [
        //     {field: 'account_type', condition: '=', value: this.typePayment === '1' ? 1 : 2},
        //     {field: 'account_name', condition: '=', value: accountName[0]},
        //   ]
        // else
          query = [{field: 'account_type', condition: '=', value: this.typePayment === '1' ? 1 : 2}]

        const { data } = await axios.post('/bank-account/query/', {
          limit: 999,
          query,
        })
        this.destinationOptions = data.rows
      } catch (e) {
        throw new Error(e)
      } finally {
        this.loading = false
      }
    },
    toObject(arr,bill) {
      let rv = {};
      for (let i = 0; i < arr.length; ++i)
        if (arr[i] !== undefined && bill[i] !== '') rv[arr[i].id] = bill[i];
      return rv;
    },
    handleRecordPayment(){
      this.form.validateFields(async (err,values)=>{
        if(!err){
          try {
            this.$vs.loading()
            if (this.typePayment === '2' || values.source === 'Direct') values.source = undefined
            const data = {
              source     : values.source,
              destination: values.destination,
              created_at : values.created_at,
              ref_id     : values.ref_id,
              billings   : this.toObject(this.billings,values.bills_pays),
            }
            await axios.post('/billing/payment/',data)
            await this.$router.push('/billing')
            this.$notification['success']({
              message: 'Success',
              description: `Record payment done successfully.`
            });
          }catch (e){
            if (e.status === 422) {
              this.$notification['error']({
                message: 'Error',
                description: e.data,
              });
            }
            if (e.status === 500) {
              this.$notification['error']({
                message: 'Error',
                description: 'Server Error',
              });
            }
            throw new Error(e)
          }finally {
            this.$vs.loading.close()
          }
        }
      })
    },
    handleChangeSource(value) {
      const findSource = this.sourceOptions.find(item => item.id === value)
      if (findSource !== undefined) this.sourceSelected = findSource
    },
    hasAmountSmallerBalance(value) {
      if (value && this.form.getFieldValue('source') !== 'Direct') {
        return value <= this.sourceSelected.balance
      }
      return true
    },
    async handleChangeClient(value) {
      await this.selectContact(value)
      await this.getSources(value)
      await this.getBankAccounts()
    },
    dashboardId(id){
      // this.is_click_add_time = false
      this.$router.push(`/billing/dashboard/${id}`)
    },
  },

  async mounted() {
    await this.getContacts()

    if (this.$route.query.client_id) {
      const id = Number(this.$route.query.client_id)
      this.form.setFieldsValue({ from_client: id })
      await this.getBankAccounts()
      await this.selectContact(id)
      if (this.typePayment === '1') {
        await this.getSources(id)
      }
    }
  },

  created() {
    this.model = TableCol.default
  }
}
</script>

<style>
@import "../style/style.css";
#payment-field .ant-form-explain,#payment-field .ant-form-extra{
  font-size: 12px !important;
}
[dir=ltr] .ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 40px;
}
</style>
